import axios from 'axios';
import { FETCH_USER,
				 FETCH_USER_ERROR,
				 FETCH_USERS,
				 FETCH_USERS_ERROR,
				 FETCH_ONE_USER,
				 FETCH_ONE_USER_ERROR,
				 FETCH_ONE_FUEHRERSCHEIN,
				 FETCH_ONE_FUEHRERSCHEIN_ERROR,
				 FETCH_FAHRER_UND_USER,
				 FETCH_SURVEYS,
				 MODAL_MESSAGE,
				 NIL_ERROR,
				 USER_UNDELETABLE_ERROR,
				 CHECK_PASSWORD_LINK_VALID,
			   FETCH_FAHRER_SUCCESS } from './types';

export * from './user.actions';
export * from './alert.actions';

export const registerUser = (user, history) => async dispatch => {
	const res = await axios.post('/api/registerUser', user);

	//console.log("registerUser action called, res.data:", res.data);
	if (res.data.err) {
		//console.log(res.data.err.code, res.data.err.message);
		if (res.data.err.code) {
			if (res.data.err.code === 11000) {
				dispatch({ type: MODAL_MESSAGE, payload: {message:"Email oder Username schon vergeben."}});
			}
		}
	} else {
		history.push('/user');
	}
	//dispatch({ type: FETCH_USER, payload: res.data });
}

export const updateUser = (user, history) => async dispatch => {
	await axios.post('/api/updateUser', user);
	//console.log("updateUser called, res.data:", res.data);
	history.push('/');
}

export const updatePassword = (values, history) => async dispatch => {
	const res = await axios.post('/api/updatePassword', values);
	//console.log("updatePassword called, res.data:", res.data);
	if (res.data.newUser) {

		const newValues = {username: values.username, password: values.password};
		dispatch(authenticateUser(newValues, history));
	} else {
		dispatch({ type: FETCH_USER_ERROR, payload: res.data.err});
	}

	//dispatch({ type: FETCH_USER, payload: res.data.newUser });
	history.push('/');
}

export const requestNewPassword = (values, history) => async dispatch => {
	const res = await axios.post('/api/passwordLost', values);
	console.log("requestNewPassword called, res.data:", values, res.data);
	if (res.data.err.hasOwnProperty('message')) {
		dispatch({ type: MODAL_MESSAGE, payload: {message:'Bitte überprüfen Sie Ihre Eingabe. ' + res.data.err.message}});
	} else {
		dispatch({ type: MODAL_MESSAGE, payload: {message:'Eine Email mit einem Link zum Zurücksetzen des Passworts ist zu Ihnen unterwegs.'}});
		history.push('/');
	}
}

export const updateLostPassword = (values, history) => async dispatch => {
	const res = await axios.post('/api/updateLostPassword', values);
	console.log("updateLostPassword called, res.data:", values, res.data);
	if (res.data.hasOwnProperty('newUser')) {
		history.push('/login');
	}
}

export const checkPasswordLinkValid = (values) => async dispatch => {
	console.log("values:", values);
	const res = await axios.post('/api/passwordLostLinkValid', values);
	console.log(res.data);
	dispatch ({ type: CHECK_PASSWORD_LINK_VALID, payload: res.data.link_valid });
}

export const removeUser = (values, history) => async dispatch => {
	//console.log("removing user");
	const res = await axios.post('/api/userRemove', values);
	dispatch({ type: FETCH_USERS, payload: res.data });
	//window.location = ('/fahrer');
}

export const logoutUser = (history) => async dispatch => {
	console.log("history in logoutUser:", history);
	const lo = await axios.get('/api/logout');
	window.location = '/';
	//history.push('/');
}

export const fetchUser = () => async dispatch => {
		const res = await axios.get('/api/current_user');

		//console.log("fetchUser action called, res.data:", res.data);
		dispatch({ type: FETCH_USER, payload: res.data });
		return (res.data);
	};

export const fetchOneUser = (email) => async dispatch => {
	try {
		const res = await axios.post('/api/user', email);
		dispatch({ type: FETCH_ONE_USER, payload: res.data });
	} catch(e) {
		dispatch({ type: FETCH_ONE_USER_ERROR, payload: e });
	}
}

// by Email UND id des Fuehererscheins (_id) da wir pro Fahrer jetzt
// mehrere Fuehrerscheine erlauben
export const fetchOneFuehrerscheinByEmail = (email, id) => async dispatch => {
	try {
		console.log("email in fetchOneFuehrerscheinByEmail:", email, id);
		const res = await axios.post('/api/fuehrerscheinByEmail', {email, id} );
		console.log("res in fetchOneFuehrerscheinByEmail:", res);
		dispatch({ type: FETCH_ONE_FUEHRERSCHEIN, payload: res.data });
	} catch (e) {
		dispatch({ type: FETCH_ONE_FUEHRERSCHEIN_ERROR, payload: e });
	}
}

export const fetchOneUserByUsername = (username) => async dispatch => {
	try {
		const res = await axios.get('/api/userByUsername/' + username);
		//console.log("userByUsername, res.data:", res.data);
		dispatch({ type: FETCH_ONE_USER, payload: res.data });
	} catch(e) {
		dispatch({ type: FETCH_ONE_USER_ERROR, payload: e });
	}
}

export const fetchOneUserByAuth = () => async dispatch => {
	//console.log("userByAuth");

	try {
		const res = await axios.get('/api/current_user');
		//console.log("userByAuth, res.data:", res.data);
		dispatch({ type: FETCH_ONE_USER, payload: res.data });
	} catch(e) {
		dispatch({ type: FETCH_ONE_USER_ERROR, payload: e });
		//console.log("error in fetchOneUserByAuth")
	}
}


export const fetchUsers = () => async dispatch => {
	try {
		const res = await axios.get('/api/listUsers');
		//console.log("res.data:", res.data);
		dispatch({ type: FETCH_USERS, payload: res.data });
	} catch(e) {
		dispatch({ type: FETCH_USERS_ERROR, payload: e })
	}
}

export const fetchFahrerUndUser = () => async dispatch => {
	try {
		const res = await axios.get('/api/listFahrerUndUser');
		dispatch({ type: FETCH_FAHRER_UND_USER, payload: res.data });
	} catch(e) {
		dispatch({ type: FETCH_USERS_ERROR, payload: e });
	}
}



export const submitFahrer = (values, history) => async dispatch => {
	//console.log("submitFahrer");
	try {
		const res = await axios.post('/api/fahrer', values);
		if (res.data.hasOwnProperty('err')) {
			console.log(res.data.err.message);
			const msg = res.data.err.message;
			if (msg.indexOf('duplicate key error')>-1) {
				dispatch({ type: MODAL_MESSAGE, payload: { message: 'Es ist schon ein Fahrer mit dieser Email angelegt.'}})
			} else {
				dispatch({ type: MODAL_MESSAGE, payload: { message: 'Es ist ein Fehler aufgetreten. Versuchen Sie es noch einmal.\n' + msg}})
			}
		} else {
			dispatch({ type: FETCH_FAHRER_SUCCESS, payload: res.data.fahrer });
			history.push('/fahrer');
		}
	} catch (e) {
		console.log(e);
	}
}

export const removeFahrer = (values, history) => async dispatch => {
	//console.log("removing fahrer");
	const res = await axios.post('/api/fahrerRemove', values);
	dispatch({ type: FETCH_FAHRER_SUCCESS, payload: res.data });
	//window.location = ('/fahrer');
}

export const submitFahrerBatch = (values, history) => async dispatch => {
	//console.log("submitFahrerBatch");
	const res = await axios.post('/api/fahrerbatch', values);
	//console.log(res.data);
	//window.location = ('/fahrer');
	//history.push('/fahrer');
	// dispatch({ type: FETCH_USER, payload: res.data });

	dispatch({ type: FETCH_FAHRER_SUCCESS, payload: res.data });
}

export const submitFuehrerschein = (values, history) => async dispatch => {
	console.log("submitFuehrerschein with values", values);

	try {
		const res = await axios.post('/api/fuehrerschein', values);
		if (res.data.hasOwnProperty('err')) {
			console.log(res.data.err.message);
			const msg = res.data.err.message;
			//console.log("error msg:", msg);
			if (msg.indexOf('duplicate key error')>-1) {
				dispatch({ type: MODAL_MESSAGE, payload: { message: 'Dieser Führerschein ist schon angelegt.'}})
			} else {
				if (msg.includes('expected `licenseId` to be unique')) {
					dispatch({ type: MODAL_MESSAGE, payload: { message: 'Konnte den Führerschein nicht speichern. Es existiert schon ein Führerschein mit dieser Nummer.'}})
				} else {
					dispatch({ type: MODAL_MESSAGE, payload: { message: 'Es ist ein Fehler aufgetreten. Versuchen Sie es noch einmal.'}})
				}
			}
		} else {
			dispatch({ type: FETCH_FAHRER_SUCCESS, payload: res.data.fahrer });
			history.push('/fahrer');
		}
	} catch (e) {
		console.log(e);
	}
}

export const removeFuehrerschein = (values, history) => async dispatch => {
	//console.log("removing fahrer");
	const res = await axios.post('/api/fuehrerscheinRemove', values);
	dispatch({ type: FETCH_FAHRER_SUCCESS, payload: res.data });
	history.push('/fahrer');
	//window.location = ('/fahrer');
}

export const fetchSurveys = () => async dispatch => {
	const res = await axios.get('/api/surveys');
	dispatch( { type: FETCH_SURVEYS, payload: res.data });
}

export const fetchFahrerSuccess = (data) => {
	//console.log("data in fetchFahrerSuccess:", data);
	return (
		{
			type: FETCH_FAHRER_SUCCESS,
			payload: data
		}
	)};

export const fetchFahrerFuhrpark = () => async dispatch => {
	//console.log("async-Methode 'fetchFahrerFuhrpark' aufgerufen");
	const res = await axios.get('/api/fahrer');
	dispatch ( { type: FETCH_FAHRER_SUCCESS, payload: res.data })
}

export const fetchFahrer = () => async dispatch => {
	const res = await axios.get('/api/fahrer');
	dispatch( { type: FETCH_FAHRER_SUCCESS, payload: res.data });
}

export const fetchFahrerByUuid = (uuid) => async dispatch => {
	const res = await axios.get('/api/fahrer/' + uuid);
	//console.log("res:", res);
	dispatch( { type: FETCH_FAHRER_SUCCESS, payload: res.data });
}

export const authenticateUser = (values, history) => async dispatch => {
	//console.log('authenticateUser action called with values', values);
	try {
		const res = await axios.post('/auth/local', values);

		console.log("res.data in authenticateUser", res.data);

		dispatch({ type: FETCH_USER, payload: res.data });
		history.push('/');
	} catch (e) {
		//console.log("error in authenticateUser");
		console.log(e);
		dispatch({ type: MODAL_MESSAGE, payload: { message: 'Login hat nicht geklappt.'}})
		dispatch({ type: FETCH_USER_ERROR, payload: e});
	}
}

export const sendFahrerMails = (values) => async dispatch => {
	//console.log("sendFahrerMails called with values", values);
	const res = await axios.post('/api/sendMails', values);
	dispatch({ type: MODAL_MESSAGE, payload: {message:"Mails verschickt."}});
	dispatch({ type: FETCH_FAHRER_SUCCESS, payload: res.data });
}

export const reportVideoSeen = (values) => async dispatch => {
	await axios.post('/api/videoSeen', values);
}

export const userUndeletable = () => async dispatch => {
	//console.log("userUndeletable called");
	dispatch ({
		type: USER_UNDELETABLE_ERROR,
		payload: {message:'Der angemeldete Benutzer kann nicht bearbeitet werden.'}
	})
}

export const modalMessage = (m) => async dispatch => {
	//console.log("modalMessage called");
	dispatch ({
		type: MODAL_MESSAGE,
		payload: {message: m}
	})
}

export const nilError = () => async dispatch => {
	//console.log("nilError called");
	dispatch ({
		type: NIL_ERROR,
		payload: null
	})
}



// WEBPACK FOOTER //
// ./src/actions/index.js